
        import type { DefaultTemplateRootProps, TemplateResult } from 'Components/types';
type fitmentTableTabDesktopRTRootProps = DefaultTemplateRootProps;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function fitmentTableTabDesktopRT(): TemplateResult<fitmentTableTabDesktopRTRootProps> {
    return this.vehicleSpecific || this.manyFitments ? _createElement('span', { 'key': '0' }, 'Fitment') : null;
}
        export const componentNames = []